<template>
  <div>
    <div class="content">
      <div class="wrapper-x-40 about">
        <h1>{{ $t('admin.views.about.title') }}</h1>
        <div
          class="about__content"
          v-if="settings && settings.about_ru"
          v-html="settings.about_ru"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
  },
};
</script>

<style>
.about__content p {
  margin-bottom: 20px;
}
.about__content h2 {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 15px;
}

.about__content a {
  text-decoration: underline;
}
</style>

